angular.module("getIdentificazione.components", [])
    .component("getIdentificazione", {
        templateUrl: "ng/components/monitorPratica/getIdentificazione/getIdentificazione.view.html",
        bindings: {
            model: "<",
            idWfInstance: "<"
        },
        controllerAs: "getIdentificazioneCtrl",
        controller: GetIdentificazione
    });

function GetIdentificazione(
    $financialService,
    $timeout,
    $download
) {
    var self = this;

    self.$onInit = function () {
        self.propMap = propMap;

    }
    self.expandSection = function () {
        self.openClose = !self.openClose;
        jQuery('#dettaglioInformazioni').slideToggle(1500);

        if (self.openClose) {
            jQuery(".icon-plus").css("transform", "rotate(225deg)");
            jQuery(".alba-input-section").css("padding", "2em 3em 2.4em 3em");
        } else {
            jQuery(".icon-plus").css("transform", "rotate(0deg)");
            $timeout(function () {
                jQuery(".alba-input-section").css("padding", "0em 3em 2.4em 3em");
            }, 1550)

        }

    }

    self.generateDownloadLink = function (id, tipo) {
        var url =
            "/uni/downloadGenericDigital/service-infos/FINANCIAL_PD/" +
            encodeURIComponent(tipo) +
            "/" +
            encodeURIComponent(id) +
            "/" +
            encodeURIComponent(self.idWfInstance) +
            "/"

        $download.getGenericDownload(url)
            .then(function (response) {
                console.log(response);
            })
    }
}